import { MANIFESTO } from "./data";
import { Reveal } from "./Reveal";

export const Manifesto = () => {
  return (
    <section id="process" data-testid="manifesto-section" className="bg-ink py-24 md:py-40 border-t border-line">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <Reveal>
          <p className="font-heading text-xs uppercase tracking-[0.3em] font-bold text-terracotta mb-6">
            [ 02 ] — The Ardú standard
          </p>
          <h2 className="font-heading font-extrabold uppercase text-bone tracking-tight leading-[0.9] text-4xl md:text-6xl lg:text-7xl max-w-4xl mb-20">
            Four chapters of craft
          </h2>
        </Reveal>

        <div className="divide-y divide-line border-y border-line">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={i * 0.05}>
              <div className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 md:py-14 hover:bg-surface transition-colors duration-500 px-2 md:px-6">
                <div className="md:col-span-2 font-heading text-5xl md:text-6xl font-black text-line group-hover:text-terracotta transition-colors duration-500">
                  {m.no}
                </div>
                <h3 className="md:col-span-4 font-heading text-3xl md:text-4xl font-extrabold uppercase text-bone tracking-tight">
                  {m.title}
                </h3>
                <p className="md:col-span-6 font-body font-light text-stone text-base md:text-lg leading-relaxed">
                  {m.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
